import { Box, Container, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 2,
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 56, color: "text.secondary" }} />
        <Typography variant="h5" fontWeight={700}>
          You don't have access to this page
        </Typography>
        <Typography color="text.secondary">
          This area is restricted to certain account types. If you think this is a
          mistake, please contact support.
        </Typography>
        <Button variant="contained" onClick={() => navigate("/")} sx={{ mt: 2 }}>
          Back to Home
        </Button>
      </Box>
    </Container>
  );
}